import React from "react";
import { Credits, Header, Usage } from "./components";

export const Topup = () => {
  return (
    <div className="atlas-p-9">
      <Header />
      <Credits />
      <Usage />
    </div>
  );
};
